<template>
  <div class="fix_dialog__wrapper" v-if="isShow">
    <div
      class="fix_dialog__center"
      :style="{'width': w + 'px', 'height': h + 'px'}">
      <div class="fix_dialog__title">
        {{title}}
        <i class="el-icon-close close_dialog" @click="hideAction"></i>
      </div>
      <div :class="['fix_dialog_main', { 'no_bottom': noBtm }]">
        <slot></slot>
      </div>
      <div class="fix_dialog_footer" v-if="!noBtm">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseFixCenter',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    w: {
      type: [String, Number],
      default: 400
    },
    h: {
      type: [String, Number],
      default: 300
    },
    noBtm: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {
    isShow: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    }
  },
  watch: {
    isShow (v) {
      if (!v) this.$emit('close', false)
    }
  },
  methods: {
    hideAction () {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.fix_dialog__wrapper {
  background: rgba(0,0,0,.3);
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1000; // 最好不要大于2000(el-date-picker的值在2000~2008，会导致日期选择器层次错乱)
  .fix_dialog__center {
    background: #fff;
    border-radius: 8px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    height: 70%;
    overflow: hidden;
  }
  .fix_dialog__title {
    border-bottom: 1px solid #e9e9e9;
    font-size: 18px;
    font-weight: 600;
    height: 50px;
    line-height: 50px;
    padding: 0 15px;
    text-align: center;
    .close_dialog {
      cursor: pointer;
      float: right;
      font-weight: 500;
      margin-top: 16px;
    }
  }
  .fix_dialog_main {
    background: #F5F5F5;
    height: calc(100% - 110px);
    overflow: auto;
    &.no_bottom {
      height: calc(100% - 50px);
    }
  }
  .fix_dialog_footer {
    border-top: 1px solid #e9e9e9;
    height: 60px;
    line-height: 60px;
    text-align: center;
    .footer-button {
      border: 1px solid #d4d4d4;
      border-radius: 4px;
      color: #282729;
      cursor: pointer;
      display: inline-block;
      width: 120px;
      height: 30px;
      line-height: 30px;
      &:not(:last-child) {
        margin-right: 20px;
      }
      &.primary { // 主色调
        background: linear-gradient(315deg, #FF846D 0%, #FF3973 100%);
        border: none;
        color: #fff;
      }
      &.dis { // 不可用
        background: #DBDBDB;
        border: 1px solid #DBDBDB;
        color: #fff;
        cursor: not-allowed;
      }
    }
  }
}
</style>
